<template>
  <article class="">
    <cabeceraEN></cabeceraEN>
      <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Financial Information</h2>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="caja">
          <h5>Annual Financial Statements</h5>
         <div class="btns">
              <div class="box">
              <p>Financial Statement</p>
              <div class="btn-ar">
                <a target="_blank" href="static/pdf/EEFF2022.pdf"><i class="icon-file-pdf"></i><h5>2022</h5></a>
              </div>
 
            <div class="box">
              <p>Financial Statement</p>
              <div class="btn-ar">
                <a target="_blank" href="static/pdf/EEFF2021.pdf"><i class="icon-file-pdf"></i><h5>2021</h5></a>
              </div>
            </div>
           <div class="box">
              <p>Financial Statement</p>
              <div class="btn-ar">
                <a target="_blank" href="static/pdf/EEFF2020.pdf"><i class="icon-file-pdf"></i><h5>2020</h5></a>
              </div>
            </div>
            <div class="box">
              <p>Financial Statement</p>
              <div class="btn-ar">
                <a target="_blank" href="static/pdf/EEFF2019.pdf"><i class="icon-file-pdf"></i><h5>2019</h5></a>
              </div>
            </div>
            <div class="box">
              <p>Financial Statement</p>
              <div class="btn-ar">
                <a target="_blank" href="static/pdf/EEFF2018.pdf"><i class="icon-file-pdf"></i><h5>2018</h5></a>
              </div>
            </div>
            <div class="box">
              <p>Financial Statement</p>
              <div class="btn-ar">
                <a target="_blank" href="static/pdf/EEFF2017.pdf"><i class="icon-file-pdf"></i><h5>2017</h5></a>
              </div>
            </div>
         </div>
          <h5 style="margin-bottom: 15px">Intermediate Financial Statements</h5>
          <p style="margin-bottom: 15px">Intermediate Financial Statements as of September 30, 2021<a target="_blank" href="static/pdf/Cia Mega - EEFF 30 de septiembre 2021 (VF).pdf"><i class="icon-file-pdf"></i></a></p>
          <p style="margin-bottom: 15px">Intermediate Financial Statements as of June 30, 2021 <a target="_blank" href="static/pdf/Cia Mega - EEFF 30 de junio 2021 (VF).pdf"><i class="icon-file-pdf"></i></a></p>
          <p style="margin-bottom: 15px">Intermediate Financial Statements as of March 31, 2021 <a target="_blank" href="static/pdf/EEFF 31 de marzo 2021.pdf"><i class="icon-file-pdf"></i></a></p>
          <p style="margin-bottom: 15px">Intermediate Financial Statements as of September 30, 2020 <a target="_blank" href="static/pdf/EEFF-30-sept-2020.pdf"><i class="icon-file-pdf"></i></a></p>
       
          <p style="margin-bottom: 15px">Intermediate Financial Statements as of June 30, 2020 <a target="_blank" href="static/pdf/EEFF-30-junio-2020.pdf"><i class="icon-file-pdf"></i></a></p>
          <p style="margin-bottom: 15px">Intermediate Financial Statements as of March 31, 2020 <a target="_blank" href="static/pdf/EEFF 31 de marzo de 2020 (COMPLETO).pdf"><i class="icon-file-pdf"></i></a></p>
          
          <h5 style="margin-top: 35px">Reports</h5>
          <p>Report on the Global Corporate Bond Issuance Program for negotiable corporate bonds no
convertible into shares for a nominal value of up to USD 500,000 - June 24, 2020 <a target="_blank" href="static/pdf/Prospecto - Compañia Mega SA.pdf"><i class="icon-file-pdf"></i></a><br><br>
          Summary Report on the Global Corporate Bond Issuance Program for negotiable corporate bonds
no convertible into shares for a nominal value of up to USD 500,000 - June 24, 2020 <a target="_blank" href="static/pdf/Prospecto Resumido - Compañia Mega SA.pdf"><i class="icon-file-pdf"></i></a></p>
           
           
        </div>
      </div>
      
    </section>
    <pieEN></pieEN>
  </article>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.btn-ar
    display: flex
    justify-content: center
    border: solid 1px #444
    width: 70px
    border-radius: 0px
    // &:hover
    // background-color: #004D9E
    &:hover
      background-color: #004D9E
      border-color: #fff
      a h5, i
        color: #fff
a h5, i 
  font-size: 15px
  padding: 0
  margin: 0
  display: inline-block
  color: black
p
  font-size: 15px
  margin: 0
  i
    &:hover
      color: #004D9E
h2
  font-size: 30px
  margin: 0
  padding: 20px 0
h5
  margin: 0
  font-size: 28px
  padding: 10px 0
.caja
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  .btns
    display: flex
    flex-direction: column
    justify-content: space-between
    max-width: 300px
    width: 100%
    padding: 10px 0
    .box
      padding-bottom: 10px
      p
        display: inline-block
        vertical-align: middle
        margin-bottom: 0
        padding-right: 20px
      .btn-ar
        display: inline-block
        vertical-align: middle
  /* Global Styles */

</style>

<script>
export default {
  name: 'info',
  components: {
    CabeceraEN,
    PieEN
  }
}
import $ from 'jquery'
import CabeceraEN from '@/components/CabeceraEN'
import PieEN from '@/components/PieEN'
$(document).ready(function () {
  $('.btn').click(function () {
    $(this).toggleClass('active')
    $('.profile .box').toggleClass('open')
  })
})
</script>




// WEBPACK FOOTER //
// src/components/info-en/info-en.vue